/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Tooltip, Icon } from '@scuf/common';
import React from 'react';

export const getCommonEUIContent = (
  header: string,
  tooltipHeader: string,
  tooltipContent: string
) => {
  return (
    <div className="emaas-sitedashboard-summary-labelWithBadge">
      <div className="emaas-sitedashboard-summary-label">{header}</div>
      <Tooltip
        className="emaas-sitedashboard-summary-tooltipsite"
        element={
          <Icon
            root="common"
            name="badge-info"
            exactSize="0.8rem"
            className="totalsavings-label-icon"
          />
        }
        event="hover"
        content={tooltipContent}
        position="right center"
        size="small"
        header={tooltipHeader}
      />
    </div>
  );
};
